import React, { useEffect, useState, useRef } from 'react';

// 基于宽度计算有几列
function getColNumByWidth(width: number) {
  if (width < 300) return 1;
  if (width < 600) return 2;
  if (width < 1200) return 3;
  return 4;
}

function getFormItemlayout(width: number) {
  if (width < 600) {
    return {
      labelCol: { span: 12 },
      wrapperCol: { span: 12 },
    };
  }
  return {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
  };
}

export default function ({
  width = 0,
  columns = [],
}) {
  // 总搜索项数
  const columnsCount = columns.length;
  // 是否展开
  const [isFold, setIsFold] = useState<boolean>(false);
  // 每行列显示数量
  const colNum = getColNumByWidth(width);
  // 显示搜索项数量
  const showCount = isFold ? columnsCount : Math.min(columnsCount, colNum > 1 ? colNum - 1 : 1);
  // 每列span
  const colSpan = 24 / colNum;
  // 按钮span
  const btnsSpan = (colNum - (showCount % colNum)) * colSpan;

  let isShowBtn = true;
  if (columnsCount <= (colNum - 1)) {
    isShowBtn = false;
  }
  const formItemLayout = getFormItemlayout(width);
  return {
    // 搜索列
    searchColumns: columns.slice(0, showCount),
    // 是否展开
    isFold,
    // 设置是否展开
    setIsFold,
    // 是否显示展开按钮
    isShowBtn,
    // 每列的span
    colSpan,
    // 搜索按钮的span
    btnsSpan,
    // form的布局配置
    formItemLayout,
  };
}
